import React, { useEffect } from 'react';

const CalendlyButton = ({ icon, alt }) => {
  const handleClick = () => {
    if (window.Calendly) {
      window.Calendly.initPopupWidget({
        url: 'https://calendly.com/expertsa-ssam/mes-projets',
      });
    }
  };

  return (
    <button onClick={handleClick} className='btnesa btn-chocolate btn-icon-right'>
        <img src={icon} alt={alt || 'Icône calendrier'} width="48" height="48" />
        <p className='h3-footer text-off-white'>Planifier un rendez-vous</p>
    </button>
  );
};

export default CalendlyButton;